// Copyright (c) 2019 Celadon Development LLC, All rights reserved.
// Author Yana Sidorova <yana.sidorova@celadon.ae>
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import classNames from 'classnames/bind';
import { connect } from 'react-redux';

import { getVoucherCode } from '../../pages/basket/store/selectors';
import * as basketActions from '../../pages/basket/store/actions';
import openBox from '../../images/open-box.png';
import clearBasket from '../../images/clear-basket.png';
import styles from './styles';
import DeleteModal from '../DeleteModal/DeleteModal';
import DiscountCircle from '../DiscountCircle/DiscountCircle';

class BasketTotal extends Component {
  state = {
    modal: false,
  };

  static propTypes = {
    classes: PropTypes.object,
    price: PropTypes.number,
    items: PropTypes.number,
    isAll: PropTypes.bool,
    marginVertical: PropTypes.bool,
    cleanBasket: PropTypes.func,
    haveClearBasket: PropTypes.bool,
    activeDiscountCode: PropTypes.object,
  };

  static defaultProps = {
    classes: {},
    price: 0,
    items: 0,
    isAll: false,
    marginVertical: false,
    cleanBasket: () => { },
    haveClearBasket: false,
    activeDiscountCode: {},
  };

  renderHelper = () => {
    const {
      classes,
      isAll,
      price,
      items,
      activeDiscountCode,
    } = this.props;
    const text = `${price.toFixed(2)} - ${items} ITEMS`;
    return (
      <div
        className={classNames(classes.helperContainer,
          isAll ? classes.isAll : classes.isNotAll)}
      >
        {Object.keys(activeDiscountCode).length
          ? <DiscountCircle
            value={activeDiscountCode.Value}
            discountType={activeDiscountCode.DiscountType}
          /> : null }
        <span className={classes.helperText}>{`£${text}`}</span>
        <div
          className={classNames(classes.triangle,
            isAll ? classes.isAllBorder : classes.isNotAllBorder)}
        />
      </div>
    );
  }

  closeModal = () => {
    this.setState({ modal: false });
  }

  openModal = () => {
    this.setState({ modal: true });
  }

  onClearBasket = () => {
    const CartID = localStorage.getItem('CartID');
    if (CartID !== null) {
      this.props.cleanBasket(CartID);
    }
    this.closeModal();
  }

  render() {
    const {
      classes,
      marginVertical,
      haveClearBasket,
    } = this.props;
    const helperDescription = '(Min order £10 or 10 items)';

    return (
      <div className={classNames(classes.mainContainer,
        marginVertical ? classes.marginVertical : classes.marginBottom)}
      >
        {this.renderHelper()}
        <div className={classes.imagesAndTotalDescriptionContainer}>
          <img className={classes.openBox} src={openBox} alt={'open box'} />
          <div className={classes.totalAndDescriptionContainer}>
            <span className={classes.basketTotalText}>BASKET TOTAL</span>
            <span className={classes.basketTotalDescriptionText}>{helperDescription}</span>
          </div>
        </div>
        {haveClearBasket && (
          <button
            className={classes.clearButtonContainer}
            onClick={this.openModal}
          >
            <img className={classes.clearBasket} src={clearBasket} alt={'clear basket'} />
            <span className={classes.clearText}>Clear basket</span>
          </button>)}
        {this.state.modal && <DeleteModal
          onAgree={this.onClearBasket}
          modal={this.state.modal}
          closeModal={this.closeModal}
          question={'Are you sure you want to delete all?'}
        />}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    voucherCode: getVoucherCode(state),
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    cleanBasket: CartID => dispatch(basketActions.cleanBasket(CartID)),
    setVoucherCode: code => dispatch(basketActions.setVoucherCode(code)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles)(BasketTotal));
